import { z } from 'my-zod'
import { dateFns, dateTimeFns, timeFns } from 'iso-fns2'
import { polarisRentalProductPricing } from './polaris-rental-product-pricing'

export const polarisRentalProductPricingUpdate = polarisRentalProductPricing
  .refine(
    (price) => {
      if (price.startTime && price.endTime) {
        const start = timeFns.toDateTime(price.startTime, dateFns.now())
        const end = timeFns.toDateTime(price.endTime, dateFns.now())
        return dateTimeFns.isBefore(start, end)
      } else {
        return true
      }
    },
    {
      message: 'start time must come before end time',
      path: ['startTime']
    }
  )
  .array()
  .superRefine((pricing, ctx) => {
    const noRestriction = pricing.filter(
      (p) =>
        !p.startDate &&
        !p.endDate &&
        !p.startTime &&
        !p.endTime &&
        !p.daysOfWeek?.length &&
        !p.minDuration &&
        !p.assetFamilyIds?.length
    )
    const restrictions = pricing.filter((p) => !noRestriction.includes(p))
    console.log(`refinement: ${JSON.stringify(noRestriction)}`)
    if (!noRestriction.length) {
      ctx.addIssue({
        message: 'At least one pricing configuration must have no restrictions.',
        code: 'custom'
      })
    } else if (restrictions.some((r) => noRestriction.every((n) => n.priority > r.priority))) {
      ctx.addIssue({
        message: 'Lowest priority pricing configuration must have no restrictions',
        code: 'custom'
      })
    }
  })

export type polarisRentalProductPricingUpdate = z.infer<typeof polarisRentalProductPricingUpdate>
